import { useQuery } from "@tanstack/react-query";
import { getClientBrandingApi } from "@/lib/api";
import { useClientSwitcherStore } from "@/stores/client-switcher.store";

// The active client's chrome: its institutional logo (null when the plan doesn't
// grant `institutional_image` or nothing was uploaded — callers then render the
// brand's own mark) and which BRAND that chrome is. Keyed on the active client so
// it refetches when a super-admin/account-manager switches schools, exactly like
// useClientFeatures.
//
// This is what makes logging in on the wrong domain a non-event: the hostname
// brands the login screen, and from here on the client decides.
export function useClientBranding() {
  const activeClientId = useClientSwitcherStore((s) => s.activeClientId);
  return useQuery({
    queryKey: ["crm", "branding", activeClientId],
    queryFn: getClientBrandingApi,
    staleTime: 60_000,
  });
}
